<template>
    <div class="container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card>
            <v-card-title>
                Division Details
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="2">
                        <v-text-field v-model="ay" label="Academic Year." readonly filled outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="standard" label="Standard" readonly filled outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="division" label="Division" readonly filled outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="totalstudents" label="Total Students" readonly filled outlined dense></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-row>
            <v-col>
                <v-card>
                    <v-data-table :headers="headers" :items="records" :search="search">
                        <template v-slot:top>
                            <v-toolbar flat color="white" align="center" justify="center">
                                <v-toolbar-title>Attendance Details</v-toolbar-title>

                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details class="no-display"></v-text-field>
                            </v-toolbar>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                            <div>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                        <template v-slot:[`item.delete`]="{ item }">
                            <div>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size" color="red" @click="deleteAttendance(item)" :loading="delete_load">mdi-trash-can</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
            headers: [
                // { text: "Day No", value: "dayno" },
                { text: "SR No", value: "srno" },
                { text: "Date", value: "date" },
                { text: "Present", value: "present" },
                { text: "Absent", value: "absent" },
                { text: "Actions", value: "action", sortable: false },
                { text: "Delete", value: "delete", sortable: false },
            ],
            totalstudents: "",
            ay: "",
            standard: "",
            division: "",
            search: "",
            records: "",
            editedItem: {
                dayno: "",
                date: "",
                present: "",
                absent: "",
                divoff: "",
                date_edit: "",
            },
            delete_load: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
        }),

        mounted() {
            this.getStudentAttendanceDetails();
        },
        methods: {
            deleteAttendance(item) {
                // alert('item'+item.divoff)
                if (!confirm("Are You Sure You Want To Delete This Date's Attendance...?")) return;
                const formData = {
                    divoff: item.divoff,
                    date: item.date,
                };
                this.delete_load = true;
                axios
                    .post("/Academics/deleteAttendance", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Deleted Successfully"); // show snackbar on success
                            //this.open_house_list = res.data.open_house_list;
                            this.getStudentAttendanceDetails();
                            this.delete_load = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.delete_load = false;
                        this.getStudentAttendanceDetails();
                    });
            },
            getStudentAttendanceDetails() {
                if (this.$store.getters.divoff_id == null) {
                    // alert('divoff')
                    this.$router.push({ name: "student-attendance" });
                }
                //this.divoff=this.$store.getters.divoff_id
                const data = {
                    divoff: this.$store.getters.divoff_id,
                    status: localStorage.getItem('setstatus_id'),
                };

                axios
                    .post("/Academics/getAttendanceDetails", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            //this.headers=res.data.headers
                            this.records = res.data.records;
                            this.ay = res.data.ay;
                            this.standard = res.data.standard;
                            this.division = res.data.division;
                            this.totalstudents = res.data.totalstudents;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            editItem(item) {
                this.editedIndex = this.records.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.$store.commit("setdivoff_id", this.editedItem.divoff);
                this.$store.commit("setedit_date", this.editedItem.date);
                this.$store.commit("setedit_date_new", this.editedItem.date_edit);
                this.$router.push({ name: "edit-attendancedetails" });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
